import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ user, sessionUnavailable = false }) => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem('token');
  
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  // Without a cached profile, the parent retry banner replaces protected screens.
  if (sessionUnavailable && !user) return null;
  return <Outlet />;
};

export default ProtectedRoute;
